module.exports = __webpack_public_path__ + "media/images/menu/supernova_remnants-8224fbc0f2f8721e37cc69faaf669680.jpg";